import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "item-center flex flex-col justify-center p-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", { class: "flex w-full items-center justify-center rounded-md bg-sky-400 py-3 text-2xl font-semibold font-semibold text-black hover:bg-sky-500 hover:text-white" }, " もどる ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-20 text-3xl font-bold" }, "お問い合わせ先", -1)
const _hoisted_5 = {
  key: 0,
  class: "mt-2 text-2xl"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-2 text-2xl"
}
const _hoisted_7 = { href: "tel:{{ groupPhone }}" }
const _hoisted_8 = {
  key: 2,
  class: "mt-10 text-3xl font-bold"
}
const _hoisted_9 = {
  key: 3,
  class: "mt-2 text-2xl"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 text-3xl font-bold" }, "このアプリについて!", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-2xl" }, "（説明）", -1)
const _hoisted_12 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignoutConfirm = _resolveComponent("SignoutConfirm")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SignoutConfirm, {
        open: _ctx.signoutConfirmOpen,
        toggleModal: _ctx.signoutConfirmToggle,
        groupId: _ctx.groupId
      }, null, 8, ["open", "toggleModal", "groupId"]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: _ctx.user ? `/${_ctx.groupId}/user/photoupload` : `/${_ctx.groupId}`,
          class: "item-center flex w-full justify-center"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _hoisted_4,
      (_ctx.groupAlias)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.groupAlias) + "市役所", 1))
        : _createCommentVNode("", true),
      (_ctx.groupPhone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.groupPhone), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.realName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "あなたのお名前"))
        : _createCommentVNode("", true),
      (_ctx.realName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.realName), 1))
        : _createCommentVNode("", true),
      _hoisted_10,
      _hoisted_11,
      (_ctx.user != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "mt-10 flex h-20 w-full items-center justify-center rounded-md bg-sky-400 py-3 text-2xl font-semibold font-semibold text-black hover:bg-sky-500 hover:text-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signoutConfirmToggle && _ctx.signoutConfirmToggle(...args)))
            }, " サインアウト ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}